<template>
    <!-- Recusa de envio explicada: o que houve, por quê, o que fazer — e o texto original
         da Meta só como "detalhe técnico". Antes a bolha mostrava a frase crua da Meta,
         em inglês, quando mostrava algo. -->
    <div class="falha-envio-meta" role="status">
        <i class="ri-error-warning-line falha-envio-meta__icone"></i>
        <div class="falha-envio-meta__corpo">
            <div class="d-flex align-items-center flex-wrap gap-1">
                <strong>{{ explicada.titulo }}</strong>
                <span v-if="explicada.codigo != null" class="falha-envio-meta__codigo" :title="`Código de erro da Meta: ${explicada.codigo}`">
                    erro {{ explicada.codigo }}
                </span>
            </div>
            <p class="mb-0">{{ explicada.explicacao }}</p>
            <p v-if="explicada.acao" class="mb-0 falha-envio-meta__acao">
                <strong class="d-inline">O que fazer:</strong> {{ explicada.acao }}
            </p>
            <template v-if="explicada.detalhe">
                <button type="button" class="falha-envio-meta__toggle" @click.stop="mostrarDetalhe = !mostrarDetalhe">
                    <i :class="mostrarDetalhe ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                    {{ mostrarDetalhe ? 'Ocultar detalhe técnico' : 'Detalhe técnico' }}
                </button>
                <code v-if="mostrarDetalhe" class="falha-envio-meta__detalhe">{{ explicada.detalhe }}</code>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { explicarFalhaDeEnvio } from '@/services/templates-wpp-meta/meta-erros-catalogo';

const props = defineProps<{
    /** `conteudo.erroCodigo` (mensagens novas) — a tradução vem por ele. */
    codigo?: string | number | null;
    /** `conteudo.erro`: frase gravada pelo servidor (nas antigas, com o inglês colado). */
    motivo?: string | null;
    /** `conteudo.erroDetalhe`: texto original da Meta. */
    detalhe?: string | null;
}>();

const mostrarDetalhe = ref(false);
const explicada = computed(() => explicarFalhaDeEnvio(props));
</script>

<style scoped>
/* Mesma linguagem visual do antigo `.envio-falha`/`.template-falha`. */
.falha-envio-meta {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    margin-top: 6px;
    padding: 8px 10px;
    border-radius: 10px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
    font-size: 12px;
    line-height: 1.4;
    max-width: 360px;
}
.falha-envio-meta__icone { font-size: 15px; line-height: 1.2; }
.falha-envio-meta__corpo { min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.falha-envio-meta__corpo strong { font-size: 12px; }
.falha-envio-meta__codigo {
    font-size: 10px;
    font-weight: 600;
    padding: 0 6px;
    border-radius: 999px;
    background: rgba(153, 27, 27, 0.1);
    border: 1px solid rgba(153, 27, 27, 0.25);
    white-space: nowrap;
}
.falha-envio-meta__acao { color: #7f1d1d; }
.falha-envio-meta__toggle {
    align-self: flex-start;
    margin-top: 2px;
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font-size: 11px;
    text-decoration: underline;
    opacity: 0.8;
    cursor: pointer;
}
.falha-envio-meta__detalhe {
    display: block;
    margin-top: 2px;
    padding: 4px 6px;
    border-radius: 6px;
    background: rgba(153, 27, 27, 0.06);
    color: inherit;
    font-size: 10.5px;
    white-space: pre-wrap;
    word-break: break-word;
}

[data-bs-theme="dark"] .falha-envio-meta {
    background: #3a1414;
    border-color: #7f1d1d;
    color: #fca5a5;
}
[data-bs-theme="dark"] .falha-envio-meta__acao { color: #fecaca; }
[data-bs-theme="dark"] .falha-envio-meta__codigo { background: rgba(252, 165, 165, 0.12); border-color: rgba(252, 165, 165, 0.3); }
[data-bs-theme="dark"] .falha-envio-meta__detalhe { background: rgba(252, 165, 165, 0.08); }
</style>
